//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SHORT_MONTH_DAY_FORMAT } from '@/lib/constants'

export default {
  name: 'DefaultPreview',
  props: {
    media: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      SHORT_MONTH_DAY_FORMAT
    }
  }
}
